/**
 * Swiper vendor entry point.
 *
 * Bundles Swiper core CSS + module CSS and the global JS registration.
 * The resulting dist/swiper.css and dist/swiper.bundle.js are registered
 * (not enqueued) in PHP so blocks can declare them as dependencies.
 *
 * @package
 */

/* eslint-disable import/no-unresolved -- Swiper v12 exports map resolves via webpack but not ESLint */
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import "swiper/css/a11y";
import "swiper/css/navigation";
/* eslint-enable import/no-unresolved */

import "./js/vendors/swiper";
